import { toast } from '@ethsign/ui';

import { createAdminTemplate, updateAdminTemplate } from '@/services';
import { SendType } from '@/types';
import { IAddFields } from '@/types/template-type';
import { ControllerBase } from '@/utils/bizify';

interface PageData {
  currentStep: number;
  loading: boolean;
  [key: string]: any;
  addFieldsData?: IAddFields;
  hasCollection?: boolean;
  collectionId?: string;
  providerId?: string;
  tags?: string;
  coverPicture?: string;
  name?: string;
  categoryId?: string;
  description?: string;
  applicableJurisdictions?: string;
}
export class PageCtrl extends ControllerBase<PageData> {
  protected $data(): PageData {
    return {
      currentStep: 0,
      loading: false,
      hasCollection: false,
      collectionId: '',
      providerId: '',
      tags: '',
      coverPicture: '',
      name: '',
      categoryId: '',
      description: '',
      applicableJurisdictions: ''
    };
  }
  setData = (data: Partial<PageData>): void => {
    Object.keys(data).forEach((key: string) => {
      this.state[key] = data[key as keyof PageData];
    });
  };
  onCreate = async (sendType: SendType, id?: string): Promise<boolean> => {
    this.state.loading = true;
    const {
      name,
      applicableJurisdictions,
      categoryId,
      providerId,
      description,
      coverPicture,
      collectionId,
      hasCollection,
      addFieldsData
    } = this.state;
    const { html, fields, signers, contractType } = addFieldsData || {};
    const data = {
      name: name,
      categoryId: Number(categoryId),
      providerId: Number(providerId),
      description: description,
      coverPicture: coverPicture,
      tags: sendType === SendType.invite ? SendType.invite : contractType,
      applicableJurisdictions: applicableJurisdictions,
      collectionId: hasCollection ? Number(collectionId) : undefined,
      contentHtml: html,
      fieldsStr: (fields && JSON.stringify(fields)) || '',
      signerFieldsStr: (signers && JSON.stringify(signers)) || ''
    };
    try {
      if (id) {
        await updateAdminTemplate(id, data);
      } else {
        await createAdminTemplate(data);
      }
    } finally {
      this.state.loading = false;
    }
    return true;
  };
  onNext = (): boolean => {
    const {
      currentStep,
      name,
      applicableJurisdictions,
      categoryId,
      providerId,
      coverPicture,
      collectionId,
      hasCollection
    } = this.state;
    if (currentStep === 2) {
      let message = '';
      if (!name) {
        message = 'Please enter the name of the template';
      }
      if (!applicableJurisdictions) {
        message = 'Please enter the applicable jurisdictions of the template';
      }
      if (!categoryId) {
        message = 'Please select the category of the template';
      }
      if (!providerId) {
        message = 'Please select the provider of the template';
      }
      if (!coverPicture) {
        message = 'Please upload the cover picture of the template';
      }
      if (hasCollection && !collectionId) {
        message = 'Please select the collection of the template';
      }
      if (message) {
        toast({
          title: 'error',
          description: message,
          variant: 'error'
        });
        return false;
      }
    }
    return true;
  };
}
